import { Injectable } from '@angular/core';
import { Location } from '@core/models/location/location';
import { LocationCreateRequest } from '@core/models/location/location-create.request';
import { LocationUpdateRequest } from '@core/models/location/location-update.request';
import { LOCATIONS, LOCATIONS_LIST_CREATE, LOCATIONS_LIST_EDIT } from '@core/router/app-states';
import {
    CreateLocationAction,
    FetchLocationAction,
    FetchLocationsAction,
    UpdateLocationAction,
    DeleteLocationAction
} from '@core/state/locations/locations-actions';
import { getDefaultLocation, getLocations, getViewedLocation, isFetching, isMultiLocation } from '@core/state/locations/locations-selectors';
import { ILocationsState } from '@core/state/locations/locations-state';
import { RouterService } from '@core/state/router/router.service';
import { IObservableAction } from '@core/state/shared/actions/observable-action';
import { getLocationEntities } from '@core/state/shared/entities/entities-selectors';
import { Store } from '@ngrx/store';
import { Observable, map } from 'rxjs';

@Injectable()
export class LocationService {
    constructor(private store$: Store<ILocationsState>,
                private routerService: RouterService
    ) {}

    fetchLocations() {
        this.store$.dispatch(new FetchLocationsAction());
    }

    getLocations(): Observable<Location[]> {
        return this.store$.select(getLocations);
    }

    fetchLocation(locationId: string) {
        this.store$.dispatch(new FetchLocationAction({ locationId }));
    }

    isFetching(): Observable<boolean> {
        return this.store$.select(isFetching);
    }

    isMultiLocation(): Observable<boolean> {
        return this.store$.select(isMultiLocation);
    }

    getLocation(locationId: string): Observable<Location> {
        return this.store$.select(getLocationEntities)
            .pipe(map((locations) => locations && locations.hasOwnProperty(locationId) && locations[locationId]))
    }

    getDefaultLocation(): Observable<Location> {
        return this.store$.select(getDefaultLocation);
    }

    viewLocation(locationId) {
        this.routerService.go(LOCATIONS_LIST_EDIT, { locationId });
    }

    viewLocations() {
        this.routerService.go(LOCATIONS);
    }

    goToLocationCreate() {
        this.routerService.go(LOCATIONS_LIST_CREATE);
    }

    createLocation(request: LocationCreateRequest): IObservableAction {
        const action: any =  new CreateLocationAction({ request });
        this.store$.dispatch(action);
        return action;
    }

    updateLocation(locationId: string, request: LocationUpdateRequest): IObservableAction {
        const action: any =  new UpdateLocationAction({ locationId, request });
        this.store$.dispatch(action);
        return action;
    }

    deleteLocation(locationId: string): IObservableAction  {
        const action: any =  new DeleteLocationAction({ locationId });
        this.store$.dispatch(action);
        return action;
    }

    getViewedLocation(): Observable<Location> {
        return this.store$.select(getViewedLocation);
    }
}
